// Global
// import 'babel-polyfill';
import {load} from '@shopify/theme-sections';

// Modules
import './layout/theme';
import './templates/templates';

load('*');
